/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../components/atoms/Loader'
import RowEmpty from '../../components/atoms/RowEmpty'
import { BadgeStatusStockTake } from '../../components/atoms/StatusLabel'
import TablePagination from '../../components/atoms/Table/TablePagination'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import MultipleSelect from '../../components/molecules/MultipleSelect'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import '../../styles/style.css'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const STOCK_TAKE_STATUSES = [
  { value: 'waiting', label: 'Waiting' },
  { value: 'ongoing', label: 'Ongoing' },
  { value: 'recheck', label: 'Recheck' },
  { value: 'done', label: 'Done' },
  { value: 'closed', label: 'Closed' }
]

const StockTake = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [warehouses, setWarehouses] = useState([])
  const [warehouseCreates, setWarehouseCreates] = useState([])
  const [visible, setVisible] = useState(false)

  const [warehouseId, setWarehouseId] = useState(
    state?.filter_warehouse_id || ''
  )
  const [q, setQ] = useState('')
  const [debouncedQ, setDebouncedQ] = useState('')
  const [status, setStatus] = useState('')

  const [dataSet, setDataSet] = useState({
    pics: [],
    checkers: []
  })

  const [form, setForm] = useState({
    step: 1,
    warehouse_id: null,
    type: 'warehouse',
    item_codes: [],
    checkboxPic: false,
    checkboxChecker: false,
    prevPic: [],
    pic: [],
    prevChecker: [],
    checker: []
  })

  const [items, setItems] = useState([])
  const [metaItems, setMetaItems] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [qItems, setQItems] = useState('')
  const [debouncedQItems, setDebouncedQItems] = useState('')
  const [isLoadingItems, setIsLoadingItems] = useState(false)

  const [data, setData] = useState([])
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  const refSrcWarehouses = useRef()
  const refSrcStatus = useRef()

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(q)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [q])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQItems(qItems)
      setMetaItems((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [qItems])

  const fetchItems = async () => {
    try {
      setIsLoadingItems(true)
      const params = {
        per_page: metaItems.per_page,
        page: metaItems.current_page,
        q: debouncedQItems,
        warehouse_id: form.warehouse_id
      }
      const response = await api.get('/master/items', { params })
      const { metadata, data: responseData } = response.data
      setItems(responseData)
      setMetaItems(metadata)
    } catch (err) {
      toast.error(err?.response?.data?.errors?.message || 'An error occurred', {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
      setItems([])
    } finally {
      setIsLoadingItems(false)
    }
  }

  useEffect(() => {
    if (form.step === 2 && form.type === 'item') {
      fetchItems()
    }
  }, [
    metaItems.current_page,
    metaItems.per_page,
    debouncedQItems,
    form.step,
    form.type,
    form.warehouse_id
  ])

  const fetchUsers = async (targetWarehouseId, type) => {
    try {
      const payload = {
        warehouse_id: targetWarehouseId,
        type
      }
      const response = await api.post('/stock-opname/users', payload)
      const { data: usersData } = response.data
      setDataSet((prevDataSet) => ({
        ...prevDataSet,
        [`${type}s`]: usersData.map((user) => ({
          ...user,
          value: user.id,
          label: user.name,
          disabled: false
        }))
      }))
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    }
  }

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: true,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data: warehouseData } = response.data
      const options = warehouseData.map((w) => ({
        value: w.id,
        label: w.warehouse_name
      }))
      setWarehouses(options)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    }
  }

  const fetchWarehouseCreate = async () => {
    try {
      const response = await api.get('/stock-opname/warehouses')
      const { data: warehouseData } = response.data
      setWarehouseCreates(warehouseData)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
    }
  }

  const fetchStockTake = async () => {
    if (!warehouseId) {
      setData([])
      setMeta({ per_page: 10, current_page: 1, total_row: 0, total_page: 0 })
      return
    }
    try {
      setIsLoading(true)
      const params = {
        per_page: meta.per_page,
        page: meta.current_page,
        warehouse_id: warehouseId,
        q: debouncedQ,
        status: status,
        type: 'stock_take'
      }
      const res = await api.get('stock-opname', { params })
      const { metadata, data: responseData } = res.data
      setData(responseData)
      setMeta(metadata)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
      setData([])
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStockTake()
  }, [meta.current_page, meta.per_page, warehouseId, debouncedQ, status])

  useEffect(() => {
    fetchWarehouse()
    fetchWarehouseCreate()
  }, [])

  const handleReset = () => {
    setQ('')
    setDebouncedQ('')
    setWarehouseId('')
    setStatus('')
    refSrcWarehouses.current?.clearValue()
    refSrcStatus.current?.clearValue()
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const columns = [
    { key: 'code', label: 'Ticket' },
    { key: 'warehouse_id', label: 'Warehouse' },
    {
      key: 'created_date',
      label: 'Created Date',
      component: (item) => item.created_at
    },
    {
      key: 'finish_date',
      label: 'Finish Date',
      component: (item) => item.finish_date || '-'
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-end',
      component: (item) => <BadgeStatusStockTake text={item.status} />
    },
    {
      key: 'berita_acara',
      label: 'Berita Acara',
      className: 'text-end',
      component: (item) => (
        <Button
          variant="transparent"
          className={`${
            item.status !== 'finish'
              ? 'btn-secondary opacity-25'
              : 'btn-primary-blue'
          }`}
          disabled={item.status !== 'finish'}
          size="sm"
        >
          Download
        </Button>
      )
    },
    {
      key: 'action',
      label: 'Action',
      className: 'text-end',
      component: (item) => (
        <button
          className="btn btn-light text-secondary border rounded"
          style={{ width: '32px', height: '32px', padding: 0 }}
          onClick={() =>
            navigate(`/stock-opname/stock-take/detail/${item.id}`, {
              state: {
                warehouse_name: item.warehouse_id,
                filter_warehouse_id: warehouseId,
                status: status,
                q: q
              }
            })
          }
        >
          <Search size={14} />
        </button>
      )
    }
  ]

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    const selectedPage = data.selected + 1
    setMeta((prevMeta) => ({ ...prevMeta, current_page: selectedPage }))
    window.scrollTo(0, 0)
  }

  const handleCloseModal = () => {
    if (form.step === 1) {
      setForm({
        step: 1,
        warehouse_id: null,
        type: 'warehouse',
        item_codes: [],
        pic: [],
        checkboxPic: false,
        checkboxChecker: false,
        checker: []
      })
      setVisible(false)
    } else if (form.step === 3 && (form.checkboxChecker || form.checkboxPic)) {
      setVisible(false)
      setTimeout(() => {
        setVisible(true)
        setForm((prevForm) => ({
          ...prevForm,
          [form.checkboxChecker ? 'checkboxChecker' : 'checkboxPic']:
            !prevForm[form.checkboxChecker ? 'checkboxChecker' : 'checkboxPic'],
          [form.checkboxChecker ? 'prevChecker' : 'prevPic']:
            prevForm[form.checkboxChecker ? 'checker' : 'pic']
        }))
      }, 300)
    } else if (form.step === 3 && !form.checkboxChecker && !form.checkboxPic) {
      setVisible(false)
      setTimeout(() => {
        setVisible(true)
        setForm((prevForm) => ({
          ...prevForm,
          step: prevForm.type === 'item' ? 2 : 1,
          pic: [],
          checker: []
        }))
      }, 300)
    } else if (form.step === 2) {
      setVisible(false)
      setTimeout(() => {
        setVisible(true)
        setForm((prevForm) => ({
          ...prevForm,
          step: 1
        }))
      }, 300)
    }
  }

  const handlePropertyModal = () => {
    if (form.step === 3) {
      let subTitle = ''
      let disabled = false
      if (form.checkboxPic) {
        subTitle = 'PIC'
      } else if (form.checkboxChecker) {
        subTitle = 'Checker'
      }
      if (
        subTitle === '' &&
        (form.pic.length === 0 || form.checker.length === 0)
      ) {
        disabled = true
      }
      if (
        subTitle !== '' &&
        ((form.checkboxPic && form.prevPic.length === 0) ||
          (form.checkboxChecker && form.prevChecker.length === 0))
      )
        disabled = true
      return {
        title: `Select Team ${subTitle}`,
        disabled,
        className: `btn fw-bold rounded px-4 ${
          disabled
            ? 'btn-secondary opacity-25'
            : 'btn-primary-orange text-white'
        }`,
        textButton:
          form.checkboxChecker || form.checkboxPic ? 'Submit' : 'Next',
        onClick: () => {
          if (subTitle !== '') {
            setVisible(false)
            setTimeout(() => {
              setVisible(true)
              setForm((prevForm) => ({
                ...prevForm,
                [subTitle === 'PIC' ? 'checkboxPic' : 'checkboxChecker']:
                  !prevForm[
                    subTitle === 'PIC' ? 'checkboxPic' : 'checkboxChecker'
                  ],
                [subTitle === 'PIC' ? 'pic' : 'checker']:
                  prevForm[subTitle === 'PIC' ? 'prevPic' : 'prevChecker']
              }))
            }, 300)
          }
          if (
            form.pic.length > 0 &&
            form.checker.length > 0 &&
            subTitle === ''
          ) {
            setVisible(false)
            navigate('/stock-opname/stock-take/create', { state: form })
          }
        }
      }
    }

    if (form.step === 2) {
      return {
        title: 'Select Item',
        disabled: form.item_codes.length === 0,
        className: `btn fw-bold rounded px-4 ${
          form.item_codes.length === 0
            ? 'btn-secondary opacity-25'
            : 'btn-primary-orange text-white'
        }`,
        textButton: 'Submit',
        onClick: () => {
          setVisible(false)
          setTimeout(() => {
            setVisible(true)
            setForm((prevForm) => ({
              ...prevForm,
              step: 3
            }))
            fetchUsers(form.warehouse_id, 'pic')
            fetchUsers(form.warehouse_id, 'checker')
          }, 300)
        }
      }
    }

    return {
      title: 'Create Stock Take',
      disabled: form.step !== 1 || ['', null].includes(form.warehouse_id),
      className: `btn fw-bold rounded px-4 ${
        form.step !== 1 || ['', null].includes(form.warehouse_id)
          ? 'btn-secondary opacity-25'
          : 'btn-primary-orange text-white'
      }`,
      textButton: 'Next',
      onClick: () => {
        setVisible(false)
        setTimeout(() => {
          setVisible(true)
          setForm((prevForm) => ({
            ...prevForm,
            step: form.type === 'item' ? 2 : 3
          }))
          if (form.type !== 'item') {
            fetchUsers(form.warehouse_id, 'pic')
            fetchUsers(form.warehouse_id, 'checker')
          }
        }, 300)
      }
    }
  }

  return (
    <Container fluid className="px-4">
      <Toaster />
      <Row className="mb-4 align-items-center">
        <Col>
          <h3 style={headerTitleStyle}>Stock Take</h3>
        </Col>
        <Col className="text-end d-flex justify-content-end gap-2">
          <Button
            variant="light"
            className="text-secondary fw-bold rounded px-3 border"
            onClick={handleReset}
            style={{ fontSize: '0.85rem' }}
          >
            <RotateCw size={16} className="me-2" />
            Reset Filters
          </Button>
          <Button
            variant="transparent"
            className="btn-primary-orange fw-bold rounded px-4"
            onClick={() => setVisible(true)}
            style={{ fontSize: '0.85rem' }}
          >
            Create
          </Button>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="g-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Ticket</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={14} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search Ticket"
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                  onChange={(e) => {
                    setQ(e.target.value)
                  }}
                  value={q}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse</Form.Label>
              <Select
                isClearable
                ref={refSrcWarehouses}
                options={warehouses}
                styles={SelectStyles}
                placeholder="All Warehouses"
                onChange={(e) => {
                  setWarehouseId(e?.value || '')
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                value={
                  warehouseId
                    ? warehouses.find((w) => w.value === warehouseId)
                    : null
                }
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Status</Form.Label>
              <Select
                isClearable
                ref={refSrcStatus}
                options={STOCK_TAKE_STATUSES}
                styles={SelectStyles}
                placeholder="All Statuses"
                onChange={(e) => {
                  setStatus(e?.value || '')
                  setMeta((prev) => ({ ...prev, current_page: 1 }))
                }}
                value={
                  status
                    ? STOCK_TAKE_STATUSES.find((s) => s.value === status)
                    : null
                }
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col md={12}>
          <Table
            hover
            responsive
            className="shadow-sm mb-5 bg-white"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
              fontSize: '0.9rem'
            }}
          >
            <thead>
              <tr>
                {columns.map((column) => (
                  <th
                    className={`p-2 align-middle ${column.className || ''}`}
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading && (
                <tr>
                  <td colSpan={columns.length} className="text-center p-5">
                    <Loader />
                  </td>
                </tr>
              )}
              {!isLoading && data.length === 0 && (
                <RowEmpty colSpan={columns.length} />
              )}
              {!isLoading &&
                data.length > 0 &&
                data.map((item, index) => (
                  <tr key={index}>
                    <td className="p-2 align-middle fw-bold">
                      {item.code || '-'}
                    </td>
                    <td className="p-2 align-middle">{item.warehouse_id}</td>
                    <td className="p-2 align-middle">{item.created_at}</td>
                    <td className="p-2 align-middle">
                      {item.finish_date ? item.finish_date : '-'}
                    </td>
                    <td className="p-2 align-middle text-end">
                      <BadgeStatusStockTake text={item.status} />
                    </td>
                    <td className="p-2 align-middle text-end">
                      <Button
                        variant="transparent"
                        className={`${
                          item.status !== 'finish'
                            ? 'btn-secondary opacity-25'
                            : 'btn-primary-blue'
                        }`}
                        disabled={item.status !== 'finish'}
                        size="sm"
                      >
                        Download
                      </Button>
                    </td>
                    <td className="p-2 align-middle text-end">
                      <button
                        className="btn btn-light text-secondary border rounded"
                        style={{ width: '32px', height: '32px', padding: 0 }}
                        onClick={() =>
                          navigate(
                            `/stock-opname/stock-take/detail/${item.id}`,
                            {
                              state: {
                                warehouse_name: item.warehouse_id,
                                filter_warehouse_id: warehouseId,
                                status: status,
                                q: q
                              }
                            }
                          )
                        }
                      >
                        <Search size={14} />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={columns.length} className="p-3 border-top-0">
                  <TablePagination
                    meta={meta}
                    handleOnChangeMeta={handleOnChangeMeta}
                    handlePageChange={handlePageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Col>
      </Row>

      <ModalStockAdjustment
        show={visible}
        title={handlePropertyModal().title}
        onHide={() => {
          handleCloseModal()
        }}
        backdrop="static"
        size={form.step === 2 && form.type === 'item' ? 'lg' : 'md'}
      >
        <Row
          className="mt-2 p-2"
          style={{
            maxHeight:
              form.step === 2 && form.type === 'item' ? '70vh' : '50vh',
            overflowY: 'auto'
          }}
        >
          {form.step === 1 && (
            <>
              <div className="my-2 text-muted opacity-75">
                <p>
                  Make sure there are no other activities beside this opname!
                </p>
                <p style={{ marginTop: '-0.3rem' }}>
                  Select warehouse to create annual opname
                </p>
              </div>
              <Col md={12}>
                <Form.Group>
                  <Form.Label style={labelStyle}>Warehouse Name</Form.Label>
                  <Form.Select
                    name="warehouse"
                    id="warehouse"
                    style={FormControlStyle}
                    value={form.warehouse_id || ''}
                    onChange={(e) => {
                      setForm((prevForm) => ({
                        ...prevForm,
                        warehouse_id: e.target.value || ''
                      }))
                    }}
                  >
                    <option value="">Select Warehouse</option>
                    {warehouseCreates.map((warehouseCreate) => (
                      <option
                        key={warehouseCreate.id}
                        value={warehouseCreate.id}
                        disabled={!warehouseCreate.is_available}
                      >
                        {warehouseCreate.warehouse_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12} className="mt-3">
                <Form.Group>
                  <Form.Label style={labelStyle}>
                    SELECT STOCK TAKE TYPE
                  </Form.Label>
                  <div className="d-flex gap-4 mt-1">
                    <Form.Check
                      type="radio"
                      id="type-warehouse"
                      label="Warehouse"
                      name="stockTakeType"
                      checked={form.type === 'warehouse'}
                      onChange={() =>
                        setForm((prev) => ({ ...prev, type: 'warehouse' }))
                      }
                      className="cursor-pointer"
                    />
                    <Form.Check
                      type="radio"
                      id="type-item"
                      label="Item"
                      name="stockTakeType"
                      checked={form.type === 'item'}
                      onChange={() =>
                        setForm((prev) => ({ ...prev, type: 'item' }))
                      }
                      className="cursor-pointer"
                    />
                  </div>
                </Form.Group>
              </Col>
            </>
          )}
          {form.step === 2 && form.type === 'item' && (
            <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <Row className="px-3">
                <Col md={12}>
                  <InputGroup className="mb-3 mt-2">
                    <InputGroup.Text
                      style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e9ecef',
                        borderRight: 'none',
                        borderTopLeftRadius: '10px',
                        borderBottomLeftRadius: '10px'
                      }}
                    >
                      <Search size={14} className="text-muted" />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search item..."
                      style={{
                        ...FormControlStyle,
                        borderLeft: 'none',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                      }}
                      onChange={(e) => {
                        setQItems(e.target.value)
                      }}
                      value={qItems}
                    />
                  </InputGroup>
                </Col>
                <Col md={12}>
                  <Table hover responsive className="mb-0">
                    <thead>
                      <tr>
                        <th
                          style={{ ...tableHeaderStyle, width: '40px' }}
                          className="text-center"
                        >
                          <input
                            type="checkbox"
                            className="form-check-input cursor-pointer shadow-none"
                            checked={
                              items.length > 0 &&
                              items.every((item) =>
                                form.item_codes.includes(item.item_code)
                              )
                            }
                            onChange={(e) => {
                              const checked = e.target.checked
                              const codes = items.map((i) => i.item_code)
                              if (checked) {
                                setForm((prev) => ({
                                  ...prev,
                                  item_codes: [
                                    ...new Set([...prev.item_codes, ...codes])
                                  ]
                                }))
                              } else {
                                setForm((prev) => ({
                                  ...prev,
                                  item_codes: prev.item_codes.filter(
                                    (c) => !codes.includes(c)
                                  )
                                }))
                              }
                            }}
                          />
                        </th>
                        <th style={tableHeaderStyle}>Item code</th>
                        <th style={tableHeaderStyle}>Item</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingItems ? (
                        <tr>
                          <td colSpan={3} className="text-center p-3">
                            <Loader />
                          </td>
                        </tr>
                      ) : items.length === 0 ? (
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center p-3 text-muted"
                          >
                            No items found
                          </td>
                        </tr>
                      ) : (
                        items.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center align-middle">
                              <input
                                type="checkbox"
                                className="form-check-input cursor-pointer shadow-none"
                                checked={form.item_codes.includes(
                                  item.item_code
                                )}
                                onChange={(e) => {
                                  const checked = e.target.checked
                                  if (checked) {
                                    setForm((prev) => ({
                                      ...prev,
                                      item_codes: [
                                        ...prev.item_codes,
                                        item.item_code
                                      ]
                                    }))
                                  } else {
                                    setForm((prev) => ({
                                      ...prev,
                                      item_codes: prev.item_codes.filter(
                                        (c) => c !== item.item_code
                                      )
                                    }))
                                  }
                                }}
                              />
                            </td>
                            <td className="align-middle fw-bold">
                              {item.item_code}
                            </td>
                            <td className="align-middle">{item.item_name}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <div className="mt-3">
                    <TablePagination
                      meta={metaItems}
                      handleOnChangeMeta={(e) => {
                        setMetaItems((prev) => ({
                          ...prev,
                          per_page: parseInt(e.target.value, 10),
                          current_page: 1
                        }))
                      }}
                      handlePageChange={(data) => {
                        setMetaItems((prev) => ({
                          ...prev,
                          current_page: data.selected + 1
                        }))
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {form.step === 3 && !form.checkboxChecker && !form.checkboxPic && (
            <>
              <Col md={12}>
                <Form.Group>
                  <Form.Label style={labelStyle}>PIC</Form.Label>
                  {form.pic.length === 0 && (
                    <Form.Select
                      name="pic"
                      id="pic"
                      style={FormControlStyle}
                      onClick={(e) => {
                        setVisible(false)
                        setTimeout(() => {
                          setVisible(true)
                          setForm((prevForm) => ({
                            ...prevForm,
                            checkboxPic: !prevForm.checkboxPic
                          }))
                        }, 300)
                      }}
                      role="button"
                      tabIndex={0}
                      className="cursor-pointer"
                    >
                      <option hidden>Select PIC (multiple)</option>
                    </Form.Select>
                  )}
                  {form.pic.length > 0 && (
                    <MultipleSelect
                      data={form?.pic || []}
                      onDelete={(value) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          pic: prevForm.pic.filter(
                            (item) => item.value !== value
                          )
                        }))
                      }}
                      onClick={(e) => {
                        setVisible(false)
                        setTimeout(() => {
                          setVisible(true)
                          setForm((prevForm) => ({
                            ...prevForm,
                            checkboxPic: !prevForm.checkboxPic
                          }))
                        }, 300)
                      }}
                    />
                  )}
                </Form.Group>
              </Col>
              <Col md={12} className="my-2">
                <Form.Group>
                  <Form.Label style={labelStyle}>CHECKER</Form.Label>
                  {form.checker.length === 0 && (
                    <Form.Select
                      name="checker"
                      id="checker"
                      style={FormControlStyle}
                      onClick={(e) => {
                        setVisible(false)
                        setTimeout(() => {
                          setVisible(true)
                          setForm((prevForm) => ({
                            ...prevForm,
                            checkboxChecker: !prevForm.checkboxChecker
                          }))
                        }, 300)
                      }}
                      role="button"
                      tabIndex={0}
                      className="cursor-pointer"
                    >
                      <option hidden>Select Checker (multiple)</option>
                    </Form.Select>
                  )}
                  {form.checker.length > 0 && (
                    <MultipleSelect
                      data={form?.checker || []}
                      onDelete={(value) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          checker: prevForm.checker.filter(
                            (item) => item.value !== value
                          )
                        }))
                      }}
                      onClick={(e) => {
                        setVisible(false)
                        setTimeout(() => {
                          setVisible(true)
                          setForm((prevForm) => ({
                            ...prevForm,
                            checkboxChecker: !prevForm.checkboxChecker
                          }))
                        }, 300)
                      }}
                    />
                  )}
                </Form.Group>
              </Col>
            </>
          )}
          {form.step === 3 && (form.checkboxChecker || form.checkboxPic) && (
            <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
              <Row className="d-flex justify-content-start pl-4 p-4 pt-2">
                <div className="form-check">
                  {dataSet[form.checkboxPic ? 'pics' : 'checkers'].length ===
                    0 && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ minHeight: '200px' }}
                    >
                      <h6 className="text-uppercase fw-bold">
                        {form.checkboxPic ? 'PIC' : 'Checker'} not available
                      </h6>
                    </div>
                  )}
                  {dataSet[form.checkboxPic ? 'pics' : 'checkers'].length > 0 &&
                    dataSet[form.checkboxPic ? 'pics' : 'checkers']?.map(
                      (valueSet) => (
                        <div
                          key={valueSet.value}
                          style={{
                            display: 'flex',
                            gap: '0.5rem',
                            marginTop: '0.8rem',
                            marginBottom: '0.8rem'
                          }}
                        >
                          <input
                            className="staging-area form-check-input cursor-pointer shadow-none"
                            type="checkbox"
                            name="stagings"
                            value={valueSet.value}
                            id={valueSet.value}
                            onChange={(e) => {
                              const { value } = e.target
                              setForm((prevForm) => ({
                                ...prevForm,
                                [form.checkboxPic ? 'prevPic' : 'prevChecker']:
                                  prevForm[
                                    form.checkboxPic ? 'prevPic' : 'prevChecker'
                                  ].find((item) => item.value === value)
                                    ? prevForm[
                                        form.checkboxPic
                                          ? 'prevPic'
                                          : 'prevChecker'
                                      ].filter((item) => item.value !== value)
                                    : [
                                        ...prevForm[
                                          form.checkboxPic
                                            ? 'prevPic'
                                            : 'prevChecker'
                                        ],
                                        {
                                          value: value,
                                          label: valueSet.label
                                        }
                                      ]
                              }))
                            }}
                            checked={form[
                              form.checkboxPic ? 'prevPic' : 'prevChecker'
                            ].find((item) => item.value === valueSet.value)}
                            role="button"
                            tabIndex={0}
                          />
                          <div className="d-flex flex-column justify-content-center">
                            <label
                              className="ms-3 rounded-2 fw-bold fs-6 cursor-pointer"
                              htmlFor={valueSet.value}
                            >
                              {valueSet.label}
                            </label>
                          </div>
                        </div>
                      )
                    )}
                </div>
              </Row>
            </div>
          )}
        </Row>
        <div className="d-flex justify-content-end mt-4">
          <button type="button" {...handlePropertyModal()}>
            {handlePropertyModal().textButton}
          </button>
        </div>
      </ModalStockAdjustment>
    </Container>
  )
}

export default StockTake
